import { IoSchool } from "react-icons/io5";
import { useGlobalContext } from "./context/globalContext";
import React, { useState, useRef, useEffect } from "react";
import { MdHealthAndSafety } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { FaMapLocation } from "react-icons/fa6";
import { IoBusiness } from "react-icons/io5";

const LocationBenefits2 = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const [activeDetail, setActiveDetail] = useState(null);
  const detailsRef = useRef(null);

  // Handle click outside to close details
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is outside both the details and the icon
      if (
        detailsRef.current &&
        !detailsRef.current.contains(event.target) &&
        !event.target.closest(".benefit-icon")
      ) {
        setActiveDetail(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle icon click
  const handleIconClick = (index, event) => {
    event.stopPropagation();
    setActiveDetail(activeDetail === index ? null : index);
  };
  const benefits = [
    {
      icon: <IoSchool />,
      title: "Educational Institutes",
      details: ["Guru Nanak College", "GNVS Inst. Of Mgmt"],
    },
    {
      icon: <MdHealthAndSafety />,
      title: "Hospitals",
      details: [
        "Dr Keny Hospital",
        "Baba Multispeciality Hosp.",
        "Sevani Health Care",
        "Antop Hill Hosp.",
      ],
    },
    {
      icon: <FaShoppingCart />,
      title: "Malls & Entertainment",
      details: [
        "Jio World Drive - 2.3km",
        "Linking Road Market - 3km",
        "Phoenix Marketcity Kurla - 7.5km",
        "Palladium Lower Parel - 8.8km",
      ],
    },
    {
      icon: <FaMapLocation />,
      title: "Connectivity",
      details: [
        "Bandra-Worli Sea Link - 1km",
        "Upcoming Metro Station - 2km",
        "Western Express Highway - 2.5km",
        "Bandra Railway Station - 3km",
        "Mumbai International Airport - 8.5km",
      ],
    },
    {
      icon: <IoBusiness />,
      title: "Business Parks",
      details: [],
    },
  ];
  return (
    <>
      <div className="section shadow-sm lazyloaded">
        <div className="lb-container">
          <div className="lb-map">
            <img src="/images/lb.PNG" alt="Location Overview" />
          </div>
          <div className="lb-content">
            <div className="lb-content-body">
              <h2 className="head text-capitalize text-center">
                {project} - Location & Connectivity
              </h2>
              <div className="cards">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className={`crd position-${index + 1}  ${
                      activeDetail === index ? "alive-card" : ""
                    } `}
                  >
                    <div
                      className="crd-icon"
                      onClick={(e) => handleIconClick(index, e)}
                    >
                      {benefit.icon}
                      <span className="crd-title">{benefit.title}</span>
                    </div>
                    {/* <div
                      ref={activeDetail === index ? detailsRef : null}
                      className={`crd-details ${
                        activeDetail === index ? "active" : ""
                      }`}
                      id="card-details-scroll"
                    >
                      <ul>
                        {benefit.details.map((detail, idx) => {
                          const parts = detail.split(" - "); 
                          if (parts.length === 2) {
                            return (
                              <li key={idx}>
                                <span>{parts[0]}</span>

                                <span>{parts[1]}</span>
                              </li>
                            );
                          } else {
                            return <li key={idx}>{detail}</li>; 
                          }
                        })}
                      </ul>
                    </div> */}
                  </div>
                ))}
              </div>
            </div>
            <div className="lb-content-footer">
              <span className="new-button " onClick={handleShowModal}>
                <span className="new-button-inner">
                  <span className="underline-animation">Get All Details</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationBenefits2;
